var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSmileBalloonIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.375 9.875S7.359 11 9 11c1.64 0 2.625-1.125 2.625-1.125m-.563-3.75h.008m-4.133 0h.008M5.25 14v1.752c0 .4 0 .6.082.702.071.089.18.14.293.14.132 0 .288-.124.6-.374l1.789-1.431c.365-.293.548-.439.752-.543.18-.092.372-.16.57-.2.225-.046.459-.046.927-.046h1.887c1.26 0 1.89 0 2.371-.245.424-.216.768-.56.984-.984.245-.48.245-1.11.245-2.371V6.35c0-1.26 0-1.89-.245-2.371a2.25 2.25 0 00-.984-.984c-.48-.245-1.11-.245-2.371-.245h-6.3c-1.26 0-1.89 0-2.371.245a2.25 2.25 0 00-.984.984c-.245.48-.245 1.11-.245 2.371V11c0 .697 0 1.046.077 1.332a2.25 2.25 0 001.59 1.591C4.205 14 4.554 14 5.25 14zm6.188-7.875a.375.375 0 11-.75 0 .375.375 0 01.75 0zm-4.126 0a.375.375 0 11-.75 0 .375.375 0 01.75 0z",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

export default SvgSmileBalloonIcon;